import React from 'react';
import { Card, Grid } from 'ui';
import { tscope } from '@i18n/index';
import { DocumentSection } from '../../../components';

const ts = tscope('Documents.payslipContent');

export const MonthlyPayslip = ({
  control,
  isDisabled,
  clearField,
  onUploadError,
  onUploadCompleted,
  onRemoveCompleted,
  otherIncomesDocument,
  monthly1PayslipDocument,
  monthly2PayslipDocument,
}) => (
  <Grid rowGap={5}>
    <Card>
      <DocumentSection
        t={ts}
        name="monthly1"
        filesCount={100}
        control={control}
        clearField={clearField}
        isDisabled={isDisabled}
        onUploadError={onUploadError}
        document={monthly1PayslipDocument}
        onUploadCompleted={onUploadCompleted}
        onRemoveCompleted={onRemoveCompleted}
      />
      <DocumentSection
        t={ts}
        name="monthly2"
        filesCount={100}
        control={control}
        isDisabled={isDisabled}
        clearField={clearField}
        onUploadError={onUploadError}
        document={monthly2PayslipDocument}
        onUploadCompleted={onUploadCompleted}
        onRemoveCompleted={onRemoveCompleted}
      />
    </Card>
    <Card>
      <DocumentSection
        t={ts}
        name="otherIncomes"
        filesCount={100}
        control={control}
        clearField={clearField}
        isDisabled={isDisabled}
        onUploadError={onUploadError}
        document={otherIncomesDocument}
        onUploadCompleted={onUploadCompleted}
        onRemoveCompleted={onRemoveCompleted}
      />
    </Card>
  </Grid>
);
